import ApexSankey from 'apexsankey';
import { Component, AfterViewInit, InputSignal, input, InputOptions, Output, EventEmitter, OnInit, signal, WritableSignal, effect, Input, ChangeDetectionStrategy, OnChanges, ViewChild, ElementRef, OnDestroy, ChangeDetectorRef, inject, viewChild } from '@angular/core';
import { TransitionProbabilitiesAdmissionToDischargeICD10 } from '../../../../interfaces/reports/transition-probabilities-admission-to-discharge-ICD10';
import { SelectModule } from "primeng/select";
import { PDropdownOptions } from '../../../../interfaces';
import { FormsModule } from '@angular/forms';
import { NgClass, TitleCasePipe } from '@angular/common';
import { BaseDashboardChartComponent } from '../../base-dashboard-chart.component';
import { ChartCardComponent } from "../../chart-card/chart-card.component";
import { TableModule } from 'primeng/table';
import { SpinnerComponent } from '../../../spinner/spinner.component';
import { TransitionDataKen } from '../../../../interfaces/reports/transition-probabilities-ken';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { TranslatePipe } from '@ngx-translate/core';
type FilterModel = 'All' | string | string[] | number[] | number;
@Component({
  selector: 'co-sankey-chart',
  standalone: true,
  templateUrl: './apex-sankey-chart.component.html',
  imports: [SelectModule, FormsModule, ChartCardComponent, TableModule, SpinnerComponent,TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SankeyChartComponent extends BaseDashboardChartComponent implements OnInit, OnDestroy, AfterViewInit {
  private cdr = inject(ChangeDetectorRef)

  // @ViewChild('sankeyChart', { static: false }) sankeyChartRef!: ElementRef<HTMLDivElement>;
  // @ViewChild('sankeyWrapper', { static: false }) sankeyWrapperRef!: ElementRef<HTMLDivElement>;
  sankeyChartRef = viewChild<ElementRef<HTMLDivElement>>('sankeyChart');
  sankeyWrapperRef = viewChild<ElementRef<HTMLDivElement>>('sankeyWrapper');


  chartReady = input.required<boolean>();
  data: InputSignal<any> = input.required();
  chartOptions = {
    nodeWidth: 20,
    spacing: 15,
    fontSize: '11px',
    fontWeight: '500',
    fontFamily: 'Helvetica, Arial',
    fontColor: '#333',
    edgeOpacity: 0.6,
    edgeGradientFill: true,
    nodeBorderColor: '#aaa',
    nodeBorderWidth: 1,
    enableToolbar: false,
    canvasStyle: '',
    width: '80%',
    height: 200,
    viewPortWidth: 800,
    viewPortHeight: 400,
    edgeMinWidth: 1,
    edgeMaxWidth: 10,
    enableTooltip: false,
    tooltipBGColor: '#fff',
    tooltipBorderColor: '#ccc',
    tooltipId: 'my-sankey-tooltip',
  };
  graphOptions: any;
  private langChangeSub?: Subscription;
  private tooltip: HTMLDivElement | null = null;

  constructor(private translate : TranslateService) {
    super();  
    
     this.langChangeSub = this.translate.onLangChange.subscribe(() => {
      const d = this.data();
    if (d?.chartData && this.sankeyChartRef()) {
        this.renderSankeyChart(d.chartData);
      }
  });
    effect(() => {
      const d = this.data();
      if (d?.chartData) {
        this.renderSankeyChart(d.chartData);

      }
    });
  }
  ngOnInit(): void { }

  ngAfterViewInit(): void {
    const d = this.data();
    if (d?.chartData?.length) {
      this.renderSankeyChart(d.chartData);

    }
  }

  private renderSankeyChart(
    chartData: TransitionProbabilitiesAdmissionToDischargeICD10['chartData']
      | TransitionDataKen[]
  ): void {
    if (!chartData || chartData.length === 0) {
      return;
    }
    if (!this.sankeyChartRef()) {
      return;
    }

    const totalCount = chartData.reduce((sum, c: any) => sum + c.count, 0);

  let nodes: any[] = [];
  let edges: any[] = [];
const t = this.translate;

if ("admissionICD10Code" in chartData[0]) {
  nodes = [
    ...Array.from(new Set(chartData.map((c: any) => c.admissionICD10Code))).map(
      (code) => ({ id: `ad_${code}`, title: `${t.instant('ICD10.ADMISSION')}: ${code}` })
    ),
    ...Array.from(new Set(chartData.map((c: any) => c.dischargeICD10Code))).map(
      (code) => ({ id: `dis_${code}`, title: `${t.instant('ICD10.DISCHARGE')}: ${code}` })
    ),
  ];

  edges = chartData.map((c: any) => {
    const percentage = ((c.count / totalCount) * 100).toFixed(2);
    return {
      source: `ad_${c.admissionICD10Code}`,
      target: `dis_${c.dischargeICD10Code}`,
      value: c.count,
      type: 'default',
      title: `
        <div style="padding: 10px; font-size: 12px; background: white; border: 1px solid #ccc;">
          <strong>${t.instant('ICD10.ADMISSION')}:</strong> ${c.admissionICD10Desc} (${c.admissionICD10Code}) <br />
          <strong>${t.instant('ICD10.DISCHARGE')}:</strong> ${c.dischargeICD10Desc} (${c.dischargeICD10Code}) <br />
          <strong>${t.instant('CHART.COUNT')}:</strong> ${c.count} <br />
          <strong>${t.instant('CHART.PERCENT')}:</strong> ${percentage}%
        </div>
      `,
    };
  });
} 

// 🔹 Αν είναι Ken dataset
else if ("kenHospitalCode" in chartData[0]) {
  nodes = [
    ...Array.from(new Set(chartData.map((c: any) => c.kenHospitalCode))).map(
      (code) => ({ id: `h_${code}`, title: `${t.instant('KEN.HOSPITAL')}: ${code}` })
    ),
    ...Array.from(new Set(chartData.map((c: any) => c.kenGatekeeperCode))).map(
      (code) => ({ id: `g_${code}`, title: `${t.instant('KEN.TPA')}: ${code}` })
    ),
  ];

  edges = chartData.map((c: any) => {
    const percentage = ((c.count / totalCount) * 100).toFixed(2);
    return {
      source: `h_${c.kenHospitalCode}`,
      target: `g_${c.kenGatekeeperCode}`,
      value: c.count,
      type: 'default',
      title: `
        <div style="padding: 10px; font-size: 12px; background: white; border: 1px solid #ccc;">
          <strong>${t.instant('KEN.HOSPITAL')}:</strong> ${c.kenHospitalDesc} (${c.kenHospitalCode}) <br />
          <strong>${t.instant('KEN.TPA')}:</strong> ${c.kenGatekeeperDesc} (${c.kenGatekeeperCode}) <br />
           <strong>${t.instant('CHART.COUNT')}:</strong> ${c.count} <br />
          <strong>${t.instant('CHART.PERCENT')}:</strong> ${percentage}%
        </div>
      `,
    };
  });
}


    const data = { nodes, edges, options: this.chartOptions };
    const container = this.sankeyChartRef()!.nativeElement;
    container.innerHTML = '';

    const sankey = new ApexSankey(container, this.chartOptions);
    sankey.render(data);

    if (!this.tooltip) {
      this.tooltip = document.createElement('div');
      this.tooltip.style.position = 'absolute';
      this.tooltip.style.pointerEvents = 'none';
      this.tooltip.style.padding = '8px';
      this.tooltip.style.background = 'white';
      this.tooltip.style.border = '1px solid #ccc';
      this.tooltip.style.fontSize = '12px';
      this.tooltip.style.display = 'none';
      document.body.appendChild(this.tooltip);
    }

    container.querySelectorAll('path').forEach((edgeElem, index) => {
      edgeElem.addEventListener('mouseenter', () => {
        if (this.tooltip) {
          this.tooltip.innerHTML = edges[index].title;
          this.tooltip.style.display = 'block';
        }
      });

      edgeElem.addEventListener('mousemove', (event: MouseEvent) => {
        if (this.tooltip) {
          this.tooltip.style.left = `${event.pageX + 10}px`;
          this.tooltip.style.top = `${event.pageY + 10}px`;
        }
      });

      edgeElem.addEventListener('mouseleave', () => {
        if (this.tooltip) this.tooltip.style.display = 'none';
      });
    });
    this.cdr.markForCheck();
  }

  ngOnDestroy(): void {
     this.langChangeSub?.unsubscribe();
    if (this.tooltip) {
      this.tooltip.remove();
      this.tooltip = null;
    }
  }

}
